export const isDefined = variable => {
  return !(typeof variable === 'undefined' || variable === null)
}
